import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import CategoryGrid from './components/CategoryGrid';
import HotDownloads from './components/HotDownloads';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Features />
        <CategoryGrid />
        <HotDownloads />
        <ArticleList />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}